import React from "react";
import Sidenav from "../components/Sidenav";
import Box from "@mui/material/Box";
import Navbar from "../components/Navbar";
import HealerList from "../healer/HealerList";
import "../Dash.css";
import { useAppStore } from "../appStore";

export default function Healer() {

  return (
    <>
      <div className="bgcolor">
        <Navbar />
        <Box height={70} />
        <Box sx={{ display: "flex" }}>
          <Sidenav />
          <Box component="main" sx={{ flexGrow: 1, p: 3 }}>
            <HealerList />
          </Box>
        </Box>
      </div>
    </>
  );
}
